import React from 'react';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import { approvePatientPrescription } from '../../services/user.service';
import { TRANSACTIONS_CONSTANT, PROGRAMS_CONSTANT } from '../../constants/common';
import { includes, values } from 'lodash';
class ApprovePrescription extends React.Component {
  _onClick = async () => {
    const { patient_id :user_id } = this.props.data;
    const { connect_program_id } = this.props.match.params;
    if (window.confirm('Do you want to approve this Prescription?')) {
      await approvePatientPrescription({
        program_id:  connect_program_id,
        user_id,
      })
        .then((res) => {
          alert(res.message);
          window.location.reload();
        })
        .catch((err) => alert(err.message));
    }
  };
  render() {
    const { transaction_status, transaction_type } = this.props.data;
    const { connect_program_id } = this.props.match.params;  
    
    return (
      <Button variant="contained" onClick={this._onClick} style={{ marginRight: 8 }} >Approve Prescription</Button>
    );
  }
}
export default withRouter(ApprovePrescription);